var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import { readOnly, reads, or } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
let UserUnits = (_dec = readOnly('currentUserData.data'), _dec2 = reads('data.subunits'), _dec3 = reads('data.merchantSubunits'), _dec4 = or('data.parentMerchant', 'multiunitParentToken'), _dec5 = computed('parentMerchantToken', '_hasParentMerchant'), _dec6 = computed('data.{isMultiunit,name,token}', 'subunits.[]'), _dec7 = computed('data.{isMultiunit,merchantSubunits.length}', '_isSingleLocation'), _dec8 = computed('_hasAccessToAllSubunits', 'merchantSubunits.length', 'subunits.length'), _class = class UserUnits extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    _initializerDefineProperty(this, "subunits", _descriptor3, this);
    _initializerDefineProperty(this, "merchantSubunits", _descriptor4, this);
    // The token of the parent merchant, if the merchant is a subunit.
    //
    // First uses `parentMerchant`, which is returned by Dashboard's
    // user API, then falls back to `multiunitParentToken` populated by
    // the server
    _initializerDefineProperty(this, "parentMerchantToken", _descriptor5, this);
    _defineProperty(this, "_hasParentMerchant", void 0);
    _defineProperty(this, "_hasAccessToAllSubunits", void 0);
    _defineProperty(this, "_isSingleLocation", void 0);
  }
  get hasParentMerchant() {
    if (this._hasParentMerchant) {
      return this._hasParentMerchant;
    }
    return !isEmpty(this.parentMerchantToken);
  }
  set hasParentMerchant(value) {
    set(this, '_hasParentMerchant', value);
  }
  get unitNames() {
    if (!this.data.isMultiunit) {
      return null;
    }
    const unitNames = {};
    for (const unit of this.subunits) {
      unitNames[unit.token] = unit.nickname;
    }
    unitNames[this.data.token] = this.data.name;
    return unitNames;
  }
  get isSingleLocation() {
    if (this._isSingleLocation !== undefined) {
      return this._isSingleLocation;
    }
    return !this.data.isMultiunit || this.data.merchantSubunits.length === 1;
  }
  set isSingleLocation(value) {
    set(this, '_isSingleLocation', value);
  }
  get hasAccessToAllSubunits() {
    if (this._hasAccessToAllSubunits !== undefined) {
      return this._hasAccessToAllSubunits;
    }
    return this.subunits?.length === this.merchantSubunits?.length;
  }
  set hasAccessToAllSubunits(value) {
    set(this, '_hasAccessToAllSubunits', value);
  }
  getSubunitMerchant(merchantToken) {
    return this.subunits.findBy('token', merchantToken);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subunits", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "merchantSubunits", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "parentMerchantToken", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasParentMerchant", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "hasParentMerchant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitNames", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "unitNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSingleLocation", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "isSingleLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasAccessToAllSubunits", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "hasAccessToAllSubunits"), _class.prototype), _class);
export { UserUnits as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.